import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://www.kapussta.com/api';

// Create axios instance with default config
const adminApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors (unauthorized)
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Authentication
export const login = async (username, password) => {
  const response = await adminApi.post('/admin/login', { username, password });
  if (response.data.success) {
    localStorage.setItem('adminToken', response.data.token);
    localStorage.setItem('adminUsername', response.data.username);
  }
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUsername');
};

export const getMe = async () => {
  const response = await adminApi.get('/admin/me');
  return response.data;
};

// File upload
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await adminApi.post('/admin/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

// Banners
export const getBanners = async () => {
  const response = await adminApi.get('/admin/banners');
  return response.data;
};

export const createBanner = async (bannerData) => {
  const response = await adminApi.post('/admin/banners', bannerData);
  return response.data;
};

export const updateBanner = async (id, bannerData) => {
  const response = await adminApi.put(`/admin/banners/${id}`, bannerData);
  return response.data;
};

export const deleteBanner = async (id) => {
  const response = await adminApi.delete(`/admin/banners/${id}`);
  return response.data;
};

// Jobs
export const getJobs = async () => {
  const response = await adminApi.get('/admin/jobs');
  return response.data;
};

export const createJob = async (jobData) => {
  const response = await adminApi.post('/admin/jobs', jobData);
  return response.data;
};

export const updateJob = async (id, jobData) => {
  const response = await adminApi.put(`/admin/jobs/${id}`, jobData);
  return response.data;
};

export const deleteJob = async (id) => {
  const response = await adminApi.delete(`/admin/jobs/${id}`);
  return response.data;
};

export const getPendingJobs = async () => {
  const response = await adminApi.get('/admin/jobs/pending');
  return response.data;
};

export const verifyJob = async (id) => {
  const response = await adminApi.put(`/admin/jobs/${id}/verify`);
  return response.data;
};



// Country Enums
export const getCountryEnums = async () => {
  const response = await adminApi.get('/admin/country-enums');
  return response.data;
};

// Contact Submissions
export const getContactSubmissions = async () => {
  const response = await adminApi.get('/admin/contact-submissions');
  return response.data;
};

export const deleteContactSubmission = async (id) => {
  const response = await adminApi.delete(`/admin/contact-submissions/${id}`);
  return response.data;
};

// Video Banners
export const getVideoBanners = async () => {
  const response = await adminApi.get('/admin/video-banners');
  return response.data;
};

export const createVideoBanner = async (bannerData) => {
  const response = await adminApi.post('/admin/video-banners', bannerData);
  return response.data;
};

export const updateVideoBanner = async (id, bannerData) => {
  const response = await adminApi.put(`/admin/video-banners/${id}`, bannerData);
  return response.data;
};

export const deleteVideoBanner = async (id) => {
  const response = await adminApi.delete(`/admin/video-banners/${id}`);
  return response.data;
};

export const updateVideoBannersSort = async (items) => {
  const response = await adminApi.put('/admin/video-banners/sort', { items });
  return response.data;
};

// Users
export const getUsers = async () => {
  const response = await adminApi.get('/admin/users');
  return response.data;
};

export const createUser = async (userData) => {
  const response = await adminApi.post('/admin/users', userData);
  return response.data;
};

export const toggleUserActive = async (id) => {
  const response = await adminApi.put(`/admin/users/${id}/toggle-active`);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await adminApi.delete(`/admin/users/${id}`);
  return response.data;
};

export default adminApi;

